<!--
Author: Jiangli
Date: 2025-03-06
Desc: 短信验证码获取以及验证弹框组件
 -->
<template>
    <div class="comp-trade-sms comp" v-on:click="blockClick">
        <div v-show="value" class="mint-msgbox-wrapper" style="position: absolute; z-index: 2001; width: 90vw">
            <div
                class="mint-msgbox"
                :style="[{'bottom': isPhone ? '0' : '22.4rem'}]"
            >
                <div class="mint-msgbox-header">
                    <div class="mint-msgbox-title">
<!--                        <img :src="$util.imgSrc('before/close')" v-on:click.stop.prevent="cancle" class="handleCancel">-->
                        请输入安全验证码
                    </div>
                </div>
                <div class="mint-msgbox-content">
                    <sms-input ref="smsInput" v-model="keyBoardObj" v-on:pwd-get="keyUpHandle" />
                    <div style="padding: 1rem 3.5rem;font-size: 1.4rem;">
<!--                        <div class="hint">已向您<span>{{$cache.getUser().mobile}}</span>的手机号发送安全验证码，请不要向陌生人透露，谨防诈骗！</div>-->
                        <div class="count-times" @click.prevent="sendCode">
                            <span v-if="time>0&&sendFlag">{{time}}秒后重新获取</span>
                            <span v-else>重新获取验证码</span>
                        </div>
                    </div>
                    <div style="text-align: center;margin-bottom: 1rem;font-size: 1.2rem;">短信验证码获取时间间隔为60S</div>
                    <div style="color: #777373;font-size: 1.2rem;text-align: center;">如需修改手机号请至“我的 – 安全设置 – 手机号码”</div>
                </div>
            </div>
            <key-board v-if="!isPhone" ref="keyBoard" :key-board-obj="keyBoardObj" v-on:pwd-get="keyUpHandle"></key-board>
        </div>
        <div v-if="value" class="v-modal" style="z-index: 2000;"></div>
    </div>
</template>
<script>
import keyBoard from "./keyBoard";
import smsInput from "./smsInput";
export default {
    name: "SmsCode",
    components: {
        keyBoard,
        smsInput
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        biztype: {
            type: String,
            default: ""
        }
    },
    data(){
        return{
            keyBoardObj: {
                curIndex: -1,
                password: []
            },
            time: 0,
            sendFlag: false,// 本次弹框弹出来之后，有没有发送验证码
            sendperiod: 0,
            isPhone: true
        };
    },
    computed: {
        // 校验表单
        errors () {
            return this.$vuerify.$errors; // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    watch: {
        value(val){
            this.sendFlag = false;
            if (val) {
                this.init();
                this.$nextTick(() => {
                    this.$refs.smsInput.inputFocus();
                });
            }
            if(val&&this.time === 0){
                this.sendSms();
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const UA = window.navigator.userAgent,
                IsAndroid =
                    /Android|HTC/i.test(UA) ||
                    !!(window.navigator["platform"] + "").match(/Linux/i),
                IsIPad = !IsAndroid && /iPad/i.test(UA),
                IsIPhone = !IsAndroid && /iPod|iPhone/i.test(UA);
            this.isPhone = IsIPhone || IsIPad || IsAndroid;
        },
        blockClick() {
            this.$refs.smsInput.inputFocus();
            return true;
        },
        cancle(){
            this.$emit("hide-sms");
            this.$refs.keyBoard.clearPasswordHandle();
        },
        keyUpHandle(val) {
            if(val){
                this.keyBoardObj.password = val.password;
                this.keyBoardObj.curIndex = val.curIndex;
            }
            if (this.keyBoardObj.password.length >= 6) {
                this.confirm();
            }
            return false;

        },
        confirm: function(){
            if(this.time===0||!this.sendFlag){
                // this.$toast("请先发送短信验证码！");
                return;
            }
            // let verifycode = "";
            // verifycode = this.keyBoardObj.password.join(" ").replace(/\s/g, "")+"";
            this.keyBoardObj.password = [];
            this.keyBoardObj.curIndex = -1;
            // let params = {
            //     verifycode:verifycode,
            //     biztype:this.biztype
            // }
            // this.$util.request("acct/smstwofactor/check",params,"POST").then(res=>{
            //     if(res.data){
            //         this.$emit("sms-get");
            //     }
            // });
        },
        sendSms() {
            // let url = "acct/twofactor/sendsms";
            // let params={
            //     mobile:this.$cache.getUser().mobile,
            //     biztype:this.biztype
            // }
            // TODO 不发送
            // this.$util.request(url, params, "POST").then(res => {
            //     if (res.data) {
            //         this.sendFlag = true;
            //         this.time = res.data[0].sendperiod;
            //         this.sendperiod = res.data[0].sendperiod;
            //         this.$util.btnDisabled(this);
            //     }
            // });
            this.sendFlag = true;
            this.time = 60;
            this.sendperiod = 60;
            // this.$util.btnDisabled(this);
        },
        // 获取验证码
        sendCode(){
            if(this.time > 0&&this.sendFlag)return;
            this.sendSms();
        },
    }
};
</script>

<style lang="scss">
.mint-msgbox {
    padding: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    position: fixed;
    background: #eaeaea;
    .mint-msgbox-header {
        padding: 0;
    }
    .mint-msgbox-btns {
        // display: inline-flex;
    }
    .mint-msgbox-title {
        font-size: 1.7rem;
        font-weight: bold;
        color: #333;
        line-height: 2.4rem;
    }
    .mint-msgbox-message {
        font-size: 1.3rem;
        color: #666;
        line-height: 2rem;
    }
    .mint-msgbox-content {
        border: none;
        padding: 1.5rem 0  2.3rem;
    }
    .mint-msgbox-confirm {
        // color: $font-red;
        display: inline-block;
        width: 50%;
        height: 4rem;
        background: #f45529;
        border-radius: 0.4rem;
        font-size: 1.5rem;
        color: #fff;
        // padding: 0rem 4.1rem;
    }
    .mint-msgbox-cancel {
        margin-right: 2rem;
        // color: $grey;
        // width: 11rem;
        // padding: 1.3rem 4.1rem;
        height: 4rem;
        background: #f1f1f1;
        border-radius: 0.4rem;
        font-size: 1.5rem;
        color: #666;
    }
}
</style>

<style lang="scss"  >
    .comp-trade-sms {
        background: #e9e9e9;
        .mint-msgbox{width: 100%; height: fit-content;padding:0;border-radius: 1.5rem 1.5rem 0 0; top: auto; }
        .mint-msgbox-title{font-size: 1.7rem;font-weight: bold; border: .1rem solid #eaeaea;}
        .mint-msgbox-title{height: 5rem;line-height: 5rem;}
        .mint-cell-value{border:1px solid #dcdcdc;border-radius: 4px;overflow: hidden;}
        .mint-field-core{text-indent: 10px;}
        .pwd-forget{padding: 0 3.5rem;text-align: right;span{display: inline-block;padding-top: 10px;}}
        .trade-msg{font-size: 1.26rem;line-height: 1.96rem;}
        .hint{
            margin-bottom: 1rem;
            line-height: 2rem;
            span{
                color: #f45529;
            }
        }
        .count-times{color: #0090FF;text-align: center;}
    }
</style>